"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = require("react-helmet");
var _commonLibs = require("@mmc/common-libs");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateBreadcrumbContent = function generateBreadcrumbContent(data, schema) {
  var domain = typeof window !== 'undefined' && window.origin ? window.origin : '__DOMAIN_URL__';
  var itemList = [];
  {
    data.map(function (link, idx) {
      return itemList.push({
        '@type': 'ListItem',
        position: idx + 1,
        name: link.label,
        item: "" + domain + link.url
      });
    });
  }
  schema['itemListElement'] = itemList;
  return {
    isSchemaApplicable: data && data.length > 0,
    result: schema
  };
};
var generateFaqPageContent = function generateFaqPageContent(data, schema) {
  var mainEntity = [];
  {
    data.map(function (question, idx) {
      return mainEntity.push({
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: "" + question.answer + question.additionalDescription
        }
      });
    });
  }
  schema['mainEntity'] = mainEntity;
  return {
    isSchemaApplicable: data && data.length > 0,
    result: schema
  };
};
var generateProductContent = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(data, schema) {
    var jsonLDData, _feefoDataJson$rating, _feefoDataJson$rating2, aggregateRating, feefoData, feefoDataJson;
    return _regenerator["default"].wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          jsonLDData = data && data.jsonLDData ? JSON.parse(data.jsonLDData) : null;
          if (!jsonLDData) {
            _context.next = 3;
            break;
          }
          _context.next = 1;
          return fetch("https://api.feefo.com/api/10/reviews/summary/product?since_period=YEAR&unanswered_feedback=include&source=on_page_product_integration&product_sku=" + data.productSkuId + "&merchant_identifier=mitsubishi-ca-en&origin=www.mitsubishi-motors.ca");
        case 1:
          feefoData = _context.sent;
          _context.next = 2;
          return feefoData.json();
        case 2:
          feefoDataJson = _context.sent;
          aggregateRating = {
            '@type': 'AggregateRating',
            ratingValue: (_feefoDataJson$rating = feefoDataJson.rating) == null ? void 0 : _feefoDataJson$rating.rating,
            ratingCount: (_feefoDataJson$rating2 = feefoDataJson.rating) == null || (_feefoDataJson$rating2 = _feefoDataJson$rating2.product) == null ? void 0 : _feefoDataJson$rating2.count
          };
          schema['aggregateRating'] = aggregateRating;
          return _context.abrupt("return", {
            isSchemaApplicable: data && data.jsonLDData ? true : false,
            result: _objectSpread(_objectSpread(_objectSpread({}, schema), JSON.parse(data.jsonLDData)), {}, {
              '@type': [schema['@type']],
              image: jsonLDData.image ? "" + window.origin + jsonLDData.image : ''
            })
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function generateProductContent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var generateBlogContent = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(data) {
    var jsonLDBlogData, datePublished, utcString;
    return _regenerator["default"].wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          jsonLDBlogData = data && data.jsonLDBlogData ? JSON.parse(data.jsonLDBlogData) : null;
          if (!jsonLDBlogData) {
            _context2.next = 1;
            break;
          }
          datePublished = jsonLDBlogData.datePublished;
          utcString = new Date(datePublished).toISOString(); // Update the publisher logo URL
          if (jsonLDBlogData.publisher && jsonLDBlogData.publisher.logo) {
            jsonLDBlogData.publisher.logo.url = "" + window.origin + jsonLDBlogData.publisher.logo.url;
          }

          // Update the id
          if (jsonLDBlogData.mainEntityOfPage && jsonLDBlogData.mainEntityOfPage['@id']) {
            jsonLDBlogData.mainEntityOfPage['@id'] = "" + window.origin + jsonLDBlogData.mainEntityOfPage['@id'];
          }
          return _context2.abrupt("return", {
            isSchemaApplicable: true,
            result: _objectSpread(_objectSpread(_objectSpread({}, jsonLDBlogData), {
              datePublished: utcString
            }), {
              image: jsonLDBlogData.image ? "" + window.origin + jsonLDBlogData.image : ''
            })
          });
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function generateBlogContent(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var generateNewsContent = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(data) {
    var jsonLDNewsData, datePublished, utcString;
    return _regenerator["default"].wrap(function (_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          jsonLDNewsData = data && data.jsonLDNewsData ? JSON.parse(data.jsonLDNewsData) : null;
          if (!jsonLDNewsData) {
            _context3.next = 1;
            break;
          }
          datePublished = jsonLDNewsData.datePublished;
          utcString = new Date(datePublished).toISOString(); // Update the publisher logo URL
          if (jsonLDNewsData.publisher && jsonLDNewsData.publisher.logo) {
            jsonLDNewsData.publisher.logo.url = "" + window.origin + jsonLDNewsData.publisher.logo.url;
          }

          // Update the id
          if (jsonLDNewsData.mainEntityOfPage && jsonLDNewsData.mainEntityOfPage['@id']) {
            jsonLDNewsData.mainEntityOfPage['@id'] = "" + window.origin + jsonLDNewsData.mainEntityOfPage['@id'];
          }
          return _context3.abrupt("return", {
            isSchemaApplicable: true,
            result: _objectSpread(_objectSpread(_objectSpread({}, jsonLDNewsData), {
              datePublished: utcString
            }), {
              image: jsonLDNewsData.image ? "" + window.origin + jsonLDNewsData.image : ''
            })
          });
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function generateNewsContent(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var generateVideoContent = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(data, schema) {
    var _ref5, videoId, videoMeta, _ref6, name, description, uploadDate, uploadDateIso, resultSchema;
    return _regenerator["default"].wrap(function (_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _ref5 = data || {}, videoId = _ref5.videoId, videoMeta = _ref5.videoMeta;
          _ref6 = videoMeta || {}, name = _ref6.name, description = _ref6.description, uploadDate = _ref6.uploadDate;
          uploadDateIso = uploadDate && !isNaN(new Date(Number(uploadDate)).getTime()) ? new Date(Number(uploadDate)).toISOString() : null;
          resultSchema = _objectSpread(_objectSpread({}, schema), {}, {
            name: name,
            description: description,
            uploadDate: uploadDateIso,
            thumbnailUrl: "https://img.youtube.com/vi/" + videoId + "/maxresdefault.jpg",
            contentUrl: "https://www.youtube.com/watch?v=" + videoId,
            embedUrl: "https://www.youtube.com/embed/" + videoId
          });
          resultSchema = (0, _commonLibs.cleanObject)(resultSchema);
          return _context4.abrupt("return", {
            isSchemaApplicable: resultSchema ? true : false,
            result: resultSchema
          });
        case 1:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function generateVideoContent(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

/* Mapping function  to map schema type with corresponding generateschema functions */
var schemaGeneratorMap = {
  BreadcrumbList: generateBreadcrumbContent,
  FAQPage: generateFaqPageContent,
  Product: generateProductContent,
  Blog: generateBlogContent,
  News: generateNewsContent,
  VideoObject: generateVideoContent
};
var StructuredData = function StructuredData(_ref7) {
  var data = _ref7.data,
    schemaType = _ref7.schemaType;
  var _useState = (0, _react.useState)(false),
    isSchemaApplicable = _useState[0],
    setIsSchemaApplicable = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    result = _useState2[0],
    setResult = _useState2[1];
  var schema = {};
  schema['@context'] = 'https://schema.org';
  schema['@type'] = schemaType;
  var schemaGeneratorFunc = schemaGeneratorMap[schemaType];
  (0, _react.useEffect)(function () {
    function updateSchema(_x7, _x8) {
      return _updateSchema.apply(this, arguments);
    }
    function _updateSchema() {
      _updateSchema = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(data, schema) {
        var _yield$schemaGenerato, _result, _isSchemaApplicable, _t;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return schemaGeneratorFunc(data, schema);
            case 1:
              _yield$schemaGenerato = _context5.sent;
              _result = _yield$schemaGenerato.result;
              _isSchemaApplicable = _yield$schemaGenerato.isSchemaApplicable;
              setIsSchemaApplicable(_isSchemaApplicable);
              setResult(_result);
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t = _context5["catch"](0);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 2]]);
      }));
      return _updateSchema.apply(this, arguments);
    }
    updateSchema(data, schema);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSchemaApplicable && /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, {
    encodeSpecialCharacters: false
  }, /*#__PURE__*/_react["default"].createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(result))));
};
var _default = exports["default"] = StructuredData;